<script>
  import VueElementLoading from 'vue-element-loading'
  import { checkVisibility } from '@utils/modal'

  export default {
    components: {
      VueElementLoading
    },
    props: {
      id: {
        type: String,
        default: 'base-modal',
      },
      title: {
        type: String,
        default: '',
      },
      action: {
        type: String,
        default: '',
      },
      size: {
        type: String,
        default: 'md',
      },
      okButton: {
        type: String,
        default: 'Ok',
      },
      isDisabledOk: {
        type: Boolean,
        default: false,
      },
      isNegative: {
        type: Boolean,
        default: false,
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
      },
      isDisabledCancel: {
        type: Boolean,
        default: false,
      },
      hasNegativeAction: {
        type: Boolean,
        default: false,
      },
      tabName: {
        type: String,
        default: null,
      },
      currentTab: {
        type: Number,
        default: null,
      },
      totalTab: {
        type: Number,
        default: null,
      },
      preserveModalOnExternalClick: {
        type: Boolean,
        default: false,
      },
      preserveModalOnEscapePress: {
        type: Boolean,
        default: false,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      centered: {
        type: Boolean,
        default: false,
      }
    },
    computed:{
      modalElementId(){
        return `${this.id}___FB_modal_outer_`
      }
    },
    methods: {
      checkVisibility,
      async handleEvent(value) {
        this.$emit('handleEvent', value)
      },
    },
  }
</script>

<template>
  <FabricModal
    :id="id"
    :size="size"
    :no-close-on-backdrop="preserveModalOnExternalClick"
    :no-close-on-esc="preserveModalOnEscapePress"
    class="!tw-z-modal"
    header-class="base-custom-border-header px-4 tw-pt-2 tw-pb-0 !tw-border-b-0"
    body-class="p-0 base-custom-modal-body"
    content-class="base-custom-modal-content"
    footer-class="base-custom-modal-footer px-4 pt-1 pb-4"
    :centered="centered"
    @shown="checkVisibility(modalElementId)"
  >
    <template v-slot:modal-header>
      <div class="custom-border-header-content text-primary py-2 w-100 tw-border-b-3 tw-border-primary tw-font-semibold">
        <div>
          {{ title }}<template v-if="tabName"> - {{ tabName }}</template>
        </div>
        <div v-if="currentTab && totalTab">
          Tab {{ currentTab }} of {{ totalTab }}
        </div>
      </div>
    </template>
    <template v-slot:modal-body>
      <VueElementLoading :active="isLoading" spinner="bar-fade-scale"/>
      <slot name="modal-body"></slot>
    </template>
    <template v-slot:modal-footer>
      <BaseContentFooter
        :is-positive-disabled="isDisabledOk"
        :is-negative-disabled="isDisabledCancel"
        :is-extra-negative-disabled="isDisabledCancel"
        :update-text="okButton"
        :cancel-text="cancelButton"
        :has-extra-negative="hasNegativeAction"
        @footer-update="handleEvent('ok')"
        @footer-cancel="handleEvent('cancel')"
      >
        <template v-if="hasNegativeAction" v-slot:extra-negative>
          <FabricDropdownElement
            element-classes="dropdown-red"
            @click="handleEvent('previous-tab')">Previous Tab
          </FabricDropdownElement>
        </template>
      </BaseContentFooter>
    </template>
  </FabricModal>
</template>
